import styled from "@emotion/styled";
import TextField from "@mui/material/TextField";
import { PageHeader } from "components/Common/Page";

export const AdminSettingLandingPageContent = styled.div(({ theme }) => ({
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const AdminSettingLandingPageHeader = styled(PageHeader)(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "20px 32px",
	button: {
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const AdminSearchContainer = styled.div(({ theme }) => ({
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 16
}));

export const SearchParagraphStyled = styled.p(({ theme }) => ({
	margin: "0 0 20px 0",
	color: theme.project.colors.fontColors.secondary,
	letterSpacing: "1px"
}));

export const AdminSearchTextField = styled(TextField)(({ theme }) => ({
	lineHeight: "var(--line-height-5)",
	paddingBottom: "8px",
	[theme.breakpoints.down("lg")]: {
		width: "100%"
	}
}));

export const AdminSearchInputLine = styled.div(({ theme }) => ({
	display: "grid",
	gap: 8,
	gridTemplateColumns: "auto max-content",
	gridTemplateRows: "40px auto",
	marginRight: "20px",
	width: "100%",
	[theme.breakpoints.down("lg")]: {
		display: "flex",
		flexDirection: "column",
		gap: 16
	}
}));
